const STORAGE_KEY = 'header_auto_collapse_enabled';

export function getHeaderAutoCollapseEnabled(): boolean {
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === null) {
    // Default to false (disabled)
    return false;
  }
  return stored === 'true';
}

export function setHeaderAutoCollapseEnabled(enabled: boolean): void {
  window.localStorage.setItem(STORAGE_KEY, String(enabled));
}
